var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"python-editor-content"},[(!_vm.editor)?_c('div',{staticClass:"edit-mask"}):_vm._e(),_c('codemirror',{ref:"mycode",attrs:{"options":_vm.cmOptions},model:{value:(_vm.curCode),callback:function ($$v) {_vm.curCode=$$v},expression:"curCode"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }